import { __assign } from "tslib";
import React, { memo } from 'react';
import stringify from 'fast-safe-stringify';
import { Alert, AlertText } from '@mercell/alert-react';
export var AlertField = memo(function (_a) {
    var field = _a.field;
    var _b = field, _c = _b.fieldWrapperProperties, fieldWrapperProperties = _c === void 0 ? {} : _c, scheme = _b.scheme, readOnlyContent = _b.readOnlyContent;
    return (React.createElement("div", __assign({}, fieldWrapperProperties),
        React.createElement(Alert, { scheme: scheme, className: "text-normal" },
            React.createElement(AlertText, { className: "text-normal" }, readOnlyContent))));
}, function (prevProps, nextProps) {
    try {
        return stringify(prevProps) === stringify(nextProps);
    }
    catch (e) {
        console.warn("AlertField: ".concat(e));
        return false;
    }
});
AlertField.displayName = 'AlertField';
